module.exports = __webpack_public_path__ + "static/media/arrow-right.feda1601.svg";